import { FC, PropsWithChildren } from 'react';

import { composeClassName } from '@utilities';

import styles from './index.module.scss';

type Props = {
	title: string;
	reverse?: boolean;
	className?: string;
};

export const Box: FC<PropsWithChildren<Props>> = ({ title, reverse, children, className }) => (
	<div
		className={composeClassName(styles.container, reverse ? styles.containerReverse : '', className)}
		data-testid="box"
	>
		<h4 className={composeClassName(styles.title, reverse ? styles.titleReverse : '')}>{title}</h4>

		{children}
	</div>
);

export default Box;
